export const baseRoute = '/o/:orgId';

export const sosWelcomeRoute = 'welcome';
export const sosHomeRoute = 'home';
export const sosSitesRoute = 'sites';
export const sosCamerasRoute = 'cameras';
export const sosAdminRoute = 'admin';
